import { datalayerAcceptedVariables } from './constants';
import { getUTM as RLGetUTM } from 'redline-client-sdk';

type AcceptedGTMVariable = (typeof datalayerAcceptedVariables)[number];
type VariablePushPayload = {
  [Key in AcceptedGTMVariable]?: string | number;
};

export default function useGTM() {
  function getDatalayer() {
    const w = window as any;
    w.dataLayer = w.dataLayer || [];
    return w.dataLayer;
  }

  function validateDataLayerPayload(variablesRecord: VariablePushPayload) {
    const notAuthorizedKeys = Object.entries(variablesRecord).filter(([key]) => !datalayerAcceptedVariables.includes(key as any));
    const isValid = !notAuthorizedKeys.length;
    const invalidKeys = notAuthorizedKeys.map(([key]) => key).join(', ');

    return { isValid, invalidKeys };
  }

  function pushVariables(variables: VariablePushPayload) {
    const { isValid, invalidKeys } = validateDataLayerPayload(variables);
    if (!isValid) {
      console.log(`GTM variables ${invalidKeys}, not acceptable`);
      return;
    }
    const dataLayer = getDatalayer();
    dataLayer.push(variables);
  }

  function createTrigger(triggerValue: string) {
    return async (datalayerVariables: VariablePushPayload = {}) => {
      const utm = RLGetUTM();

      pushVariables({
        event: triggerValue,
        // used to some triggers like closeDeal [partner]
        utm_source: utm.source || '',
        utm_medium: utm.medium || '',
        utm_term: utm.term || '',
        ...datalayerVariables,
      });
    };
  }

  const trigger = {
    loginWithSuccess: createTrigger('Login com sucesso'),
    registerWithSuccess: createTrigger('Cadastro com sucesso'),
    userFindSimulation: createTrigger('Simulação'),
    pixGenerated: createTrigger('Pix Gerado'),
    pixPayed: createTrigger('Pix Pago'),
    debtFound: createTrigger('Dívida localizada'),
    agreement: createTrigger('Acordo'),
    checkout: createTrigger('Checkout'),
  };

  return { pushVariables, trigger };
}
